import {  Chip, Divider, Grid, Stack, Typography } from '@mui/material';

import { Section } from '@/modules/common/components/Section';
import { useHasOmniVehicles } from '@/modules/vehicles/hooks/useHasOmniVehicles';

import { OpenAllFloorplanButton } from './OpenAllFloorplanButton';
import { DownloadFloorplanButton } from './DownloadFloorPlanButton';
import { LogCurrentFddmButton } from './LogCurrentFddmButton';
import { LogCurrentCanvasElementsButton } from './LogCurrentCanvasElementsButton';
import { LogSelectedElementsButton } from './LogSelectedElementsButton';
import { ResetPreferencesButton } from './ResetPreferencesButton';
import { ShowFpsOnCanvas } from './ShowFpsButton';

export const DEBUG_DESCRIPTION_SIZE = 8;
export const DEBUG_ACTION_SIZE = 4;

export function DebugModal() {
  const hasOmniVehicles = useHasOmniVehicles();

  return (
    <Stack direction='column' spacing={2.5} sx={{ width: '100%', minWidth: 700 }}>
      <Typography variant='h3'>Debug menu</Typography>
      <Divider />
      <Stack direction='column' spacing={2.5} sx={{ width: '100%' }}>
        <Section title='Floorplan'>
          <Grid container spacing={2} alignItems='center'>
            <OpenAllFloorplanButton />
            <DownloadFloorplanButton />
          </Grid>
        </Section>

        <Divider />

        <Section title='Logging'>
          <Grid container spacing={2} alignItems='center'>
            <LogCurrentFddmButton />
            <LogCurrentCanvasElementsButton />
            <LogSelectedElementsButton />
            <ResetPreferencesButton />
            <ShowFpsOnCanvas />
          </Grid>
        </Section>

        <Divider />

        <Section title='Omni settings'>
          <Grid container spacing={2} alignItems='center'>
            <Grid item xs={DEBUG_DESCRIPTION_SIZE}>
              <Typography>Omni vehicles</Typography>
            </Grid>
            <Grid item xs={DEBUG_ACTION_SIZE}>
              <Chip
                size='small'
                label={hasOmniVehicles ? 'YES' : 'NO'}
                color={hasOmniVehicles ? 'success' : 'default'}
              />
            </Grid>
          </Grid>
        </Section>
      </Stack>
    </Stack>
  );
}
